import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SessionService } from '../../core/services/session/session.service';

@Component({
	selector: 'app-session-time-out',
	templateUrl: './session-time-out.component.html',
	styleUrls: ['./session-time-out.component.scss']
})
export class SessionTimeOutComponent implements OnInit {

	constructor(@Inject(MAT_DIALOG_DATA) public data: { code: number }, private sessionService: SessionService) { }

	ngOnInit(): void {

	}

	reload() {
		this.sessionService.reloadToRoot()
	}

}
